import AdminCreateMedalForm from "../components/AdminCreateMedalForm";

const AdminCreateMedal = () => {
    

    return (
        <div style={{ padding: "20px", maxWidth: "400px" }}>
            <h2>Create Medal</h2>
            <AdminCreateMedalForm />
        </div>
    )
}

export default AdminCreateMedal;